import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/components/HomePage'
import ProductList from '@/components/ProductList'
import Category from '@/components/Category'
import Product from '@/components/Product'
import ShopCart from '@/components/ShopCart'
import Compare from '@/components/Compare'
import CompareResult from '@/components/CompareResult'
import Comment from '@/components/Comment'
import AllComment from '@/components/AllComment'
import FilterResult from '@/components/FilterResult'
import SubmitOrder from '@/components/SubmitOrder'
import PaySuccess from '@/components/PaySuccess'
import PayType from '@/components/PayType'
import InvoiceEdit from '@/components/InvoiceEdit'
import ComputedOrder from '@/components/ComputedOrder'

Vue.use(Router)


export default new Router({
  routes: [
    {
      path: '/HomePage',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/ProductList',
      name: 'ProductList',
      component: ProductList
    },
    {
      path: '/Category',
      name: 'Category',
      component: Category
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product
    },
    {
      path: '/ShopCart',
      name: 'ShopCart',
      component: ShopCart
    },
    {
      path: '/Compare',
      name: 'Compare',
      component: Compare
    },
    {
      path: '/CompareResult',
      name: 'CompareResult',
      component: CompareResult
    },
    {
      path: '/Comment',
      name: 'Comment',
      component: Comment
    },
    {
      path: '/AllComment',
      name: 'AllComment',
      component: AllComment
    },
    {
      path: '/FilterResult',
      name: 'FilterResult',
      component: FilterResult
    },
    {
      path: '/SubmitOrder',
      name: 'SubmitOrder',
      component: SubmitOrder
    },
    {
      path: '/PaySuccess',
      name: 'PaySuccess',
      component: PaySuccess
    },
    {
      path: '/ComputedOrder',
      name: 'ComputedOrder',
      component: ComputedOrder
    },
    {
      path: '/PayType',
      name: 'PayType',
      component: PayType
    },
    {
      path: '/InvoiceEdit',
      name: 'InvoiceEdit',
      component: InvoiceEdit
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js